import { Announcement } from 'functions/src/types/firestore/Game/Announcement';
import { PatchIcon } from '../icons/PatchIcon';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import StarIcon from '@mui/icons-material/Star';
import { Variant } from '@mui/material/styles/createTypography';
import { SvgIconProps } from '@mui/material/SvgIcon';
import Typography from '@mui/material/Typography';
import { FunctionComponent } from 'react';
import { GradientIcon } from '../gradients/GradientIcon';
import { SxProps } from '@mui/material';

type AnnouncementType = Announcement['type'];

type GameAnnouncementIconProps = {
  announcementType: AnnouncementType;
  typographyVariant?: Variant;
  sx?: SxProps;
};

export function GameAnnouncementIcon({
  announcementType,
  typographyVariant,
  sx = {},
}: GameAnnouncementIconProps) {
  if (!announcementType) return null;

  const announcementIconMap: {
    [announcementType in AnnouncementType]: FunctionComponent<SvgIconProps>;
  } = {
    leaderboard: AttachMoneyIcon,
    patch: PatchIcon,
    event: LiveTvIcon,
    asset: StarIcon,
  };

  const SpecificIcon: FunctionComponent<SvgIconProps> =
    announcementIconMap[`${announcementType}`];
  return (
    <>
      {!!typographyVariant ? (
        <Typography variant={typographyVariant} lineHeight={0}>
          <GradientIcon
            IconComponent={SpecificIcon}
            sx={{ fontSize: 'inherit', ...sx }}
          />
        </Typography>
      ) : (
        <GradientIcon
          IconComponent={SpecificIcon}
          sx={{ fontSize: 'inherit', ...sx }}
        />
      )}
    </>
  );
}
